<!-- Send Email Dialog -->
<p-dialog 
  [visible]="true"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px' }"
  [baseZIndex]="0"
  class="neo-dialog">
  
  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">{{sendMailHeader}}</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="closeSendEmail()"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        
        <!-- Documentation Form -->
        <form *ngIf="sendDocumentation" [formGroup]="sendEmailForm" class="send-email-form">
          <!-- 1. Job Role -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Job Role <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              formControlName="documentCohortJobRole" 
              [options]="jobRolesList" 
              optionLabel="label" 
              appendTo="body"
              (onChange)="onDocumentationJobRoleChange($event.value)"
              #documentCohortJobRole
              [panelStyle]="{
                  'min-width': documentCohortJobRole.el.nativeElement.offsetWidth + 'px',
                  'max-width': documentCohortJobRole.el.nativeElement.offsetWidth + 'px'
              }"
              optionValue="value"
              placeholder="Choose a job role">
            </p-select>
            <div *ngIf="clicked && !sendEmailForm.controls['documentCohortJobRole'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 2. Job Location -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Job Location</label>
            <p-multiselect 
              bigger
              class="form-multiselect" 
              formControlName="documentCohortLocation" 
              [options]="documentationLocationsList" 
              optionLabel="label" 
              optionValue="value" 
              [(ngModel)]="selectedLocation"
              display="chip"
              placeholder="Choose job locations">
            </p-multiselect>
          </div>

          <!-- 3. Document POC Role -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Document POC Role <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              [filter]="true" 
              [filterBy]="'name'" 
              optionLabel="name" 
              (onChange)="getOwnerDetails($event.value)" 
              optionValue="id"  
              appendTo="body"
              #ms
              [panelStyle]="{
                  'min-width': ms.el.nativeElement.offsetWidth + 'px',
                  'max-width': ms.el.nativeElement.offsetWidth + 'px'
              }"
              [options]="roles"
              placeholder="Choose a POC role">
        </p-select>
          </div>

          <!-- 4. Documentation POC -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Documentation POC <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              [filter]="true" 
              [filterBy]="'label'" 
              optionLabel="label" 
              appendTo="body"
              optionValue="value" 
              [options]="eventUsers" 
              #docPocEl
              [panelStyle]="{
                  'min-width': docPocEl.el.nativeElement.offsetWidth + 'px',
                  'max-width': docPocEl.el.nativeElement.offsetWidth + 'px'
              }"
              formControlName="documentPOC"
              placeholder="Choose a POC">
        </p-select>
            <div *ngIf="clicked && !sendEmailForm.controls['documentPOC'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 5. Document Submission Deadline -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Document Submission Deadline <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              appendTo="body"
              formControlName="documentDeadline" 
              [options]="deadlineList" 
              optionLabel="label" 
              #documentDeadline
              [panelStyle]="{
                  'min-width': documentDeadline.el.nativeElement.offsetWidth + 'px',
                  'max-width': documentDeadline.el.nativeElement.offsetWidth + 'px'
              }"
              optionValue="value"
              placeholder="Choose a deadline">
          </p-select>
            <div *ngIf="clicked && !sendEmailForm.controls['documentDeadline'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 6. Email Template -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Email Template</label>
            <p-select 
              class="form-dropdown" 
              [filter]="true" 
              filterBy="templateTitle" 
              optionLabel="templateTitle"
              appendTo="body"
              #template
              [panelStyle]="{
                  'min-width': template.el.nativeElement.offsetWidth + 'px',
                  'max-width': template.el.nativeElement.offsetWidth + 'px'
              }"
              formControlName="template"
              [options]="templatesList" 
              (onChange)="emailWrite($event)"
              placeholder="Choose a template">
        </p-select>
            <div *ngIf="clicked && !sendEmailForm.get('template')?.valid" class="error-message">
              This field is required!
            </div>
            <span class="error-paceholder p-error" *ngIf="errorPlaceholder.length">
              Please select a template that includes: 
              <span *ngFor="let p of errorPlaceholder; let i = index">{{ i > 0 ? ', ' : '' }}{{ p }}</span>
            </span>
          </div>

          <!-- 7. From -->
          <div class="form-field">
            <label class="field-label">From <span class="required-asterisk">*</span></label>
            <input 
              type="email" 
              pInputText 
              formControlName="fromAddress"
              readonly
              class="form-input">
          </div>

          <!-- 8. Attachment -->
          <div class="form-field">
            <label class="field-label">Attachment</label>
            <div class="upload-container">
              <div *ngIf="!attachmentFile || attachmentFile.length === 0" class="upload-dropzone" ngx-dropzone
            [accept]="'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf'"
                [multiple]="false" 
                (change)="onSelectMedia($event, true)" 
                [maxFileSize]="2000000">
                <ngx-dropzone-label *ngIf="!uploadingFile" class="dropzone-content">
                  <div class="upload-icon">
                <em class="pi pi-cloud-upload"></em>
                  </div>
                  <div class="upload-text">
                    Click to <span class="upload-link">upload</span> or Drag & Drop
                  </div>
                  <div class="upload-format">.XLSX, .CSV .DOCX .PDF Formats only</div>
                  <div class="upload-format">File should be Less than 2MB</div>
                </ngx-dropzone-label>
                <div *ngIf="uploadingFile" class="upload-loading">
                  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
                  </p-progressSpinner>
                </div>
              </div>
              
              <div *ngIf="attachmentFile && attachmentFile.length > 0" class="uploaded-file-container">
                <div class="uploaded-file-info" *ngFor="let f of attachmentFile">
                  <div class="file-icon">
                    <em class="pi pi-file"></em>
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ f.name }}</div>
                  </div>
                  <button 
                    type="button" 
                    class="remove-file-btn"
                    (click)="onRemoveMedia(f)">
                    <em class="pi pi-times"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 9. Subject -->
          <div class="form-field">
            <label class="field-label">Subject <span class="required-asterisk">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="subjectTitle"
              [ngClass]="{'invalid': clicked && !sendEmailForm.get('subjectTitle')?.valid}"
              class="form-input">
            <div *ngIf="clicked && !sendEmailForm.get('subjectTitle')?.valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 10. Message -->
          <div class="form-field">
            <div class="message-header">
              <label class="field-label" required>Message</label>
              <div class="message-actions" *ngIf="selectedTemplate">
                <span class="label-action" *ngIf="!editingTemplate" (click)="editEmailTemplate(true)">Edit</span>
                <span class="label-action" *ngIf="editingTemplate && placeholders.length" (click)="showPlaceholder = true">Add Placeholder</span>
                <span class="label-action" *ngIf="editingTemplate" (click)="editEmailTemplate(false)">Close</span>
              </div>
            </div>
  
            <div *ngIf="!editingTemplate && selectedTemplate" class="template-display" style="overflow-y: auto;">
              <div [innerHTML]="selectedTemplate?.body | getSafeHTMLEmail" style="pointer-events: none;">
              </div>
            </div>
            
            <div *ngIf="editingTemplate || !selectedTemplate" class="template-editor">
              <textarea placeholder="Email Body" id="content"></textarea>
            </div>
          </div>
      </form>
  
        <!-- Offer Form -->
        <form *ngIf="assignCohortData" [formGroup]="sendOfferForm" class="send-email-form">
          <!-- 1. Job Role -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Job Role <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              formControlName="cohortJobRole" 
              [options]="jobRolesList" 
              optionLabel="label" 
              optionValue="value"
              (onChange)="onOfferJobRoleChange($event.value)"
              placeholder="Choose a job role">
            </p-select>
            <div *ngIf="clicked && !sendOfferForm.controls['cohortJobRole'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 2. Job Location -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Job Location <span class="required-asterisk">*</span></label>
            <p-multiselect 
              class="form-multiselect" 
              formControlName="cohortJobLocation" 
              [options]="offerLocationsList" 
              optionLabel="label" 
              optionValue="value" 
              [(ngModel)]="selectedLocation"
              display="chip"
              placeholder="Choose job locations">
            </p-multiselect>
            <div *ngIf="clicked && !sendOfferForm.controls['cohortJobLocation'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 3. Offer Acceptance Deadline -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Offer Acceptance Deadline <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              formControlName="offerDeadline" 
              [options]="deadlineList" 
              optionLabel="label" 
              optionValue="value"
              placeholder="Choose a deadline">
      </p-select>
            <div *ngIf="clicked && !sendOfferForm.controls['offerDeadline'].valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 4. Email Template -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Email Template <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              [filter]="true" 
              filterBy="templateTitle" 
              optionLabel="templateTitle"
              formControlName="template"
              [options]="templatesList" 
              (onChange)="emailWrite($event)"
              placeholder="Choose a template">
      </p-select>
            <div *ngIf="clicked && !sendOfferForm.get('template')?.valid" class="error-message">
              This field is required!
            </div>
            <span class="error-paceholder p-error" *ngIf="errorPlaceholder.length">
              Please select a template that includes: 
              <span *ngFor="let p of errorPlaceholder; let i = index">{{ i > 0 ? ', ' : '' }}{{ p }}</span>
            </span>
          </div>

          <!-- 5. Subject -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Subject <span class="required-asterisk">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="subjectTitle"
              [ngClass]="{'invalid': clicked && !sendOfferForm.get('subjectTitle')?.valid}"
              class="form-input">
            <div *ngIf="clicked && !sendOfferForm.get('subjectTitle')?.valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 6. Message -->
          <div class="form-field neo-input-wrapper">
            <div class="message-header">
              <label class="field-label" required>Message</label>
              <div class="message-actions" *ngIf="selectedTemplate">
                <span class="label-action" *ngIf="!editingTemplate" (click)="editEmailTemplate(true)">Edit</span>
                <span class="label-action" *ngIf="editingTemplate && placeholders.length" (click)="showPlaceholder = true">Add Placeholder</span>
                <span class="label-action" *ngIf="editingTemplate" (click)="editEmailTemplate(false)">Close</span>
              </div>
            </div>
            
            <div *ngIf="!editingTemplate && selectedTemplate" class="template-display" style="overflow-y: auto;">
              <div [innerHTML]="selectedTemplate?.body | getSafeHTMLEmail" style="pointer-events: none;">
              </div>
            </div>
            
            <div *ngIf="editingTemplate || !selectedTemplate" class="template-editor">
              <textarea placeholder="Email Body" id="content"></textarea>
            </div>
          </div>
        </form>

        <!-- Regular Email Form -->
        <form *ngIf="!assignCohortData && !sendDocumentation" [formGroup]="sendEmailForm" class="send-email-form">
          <!-- 1. Email Template -->
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Email Template</label>
            <p-select 
              class="form-dropdown" 
              [filter]="true" 
              filterBy="templateTitle" 
              optionLabel="templateTitle"
              formControlName="template"
              [options]="templatesList" 
              (onChange)="emailWrite($event)"
              placeholder="Choose a template">
      </p-select>
          </div>

          <!-- 2. From -->
          <div class="form-field">
            <label class="field-label">From <span class="required-asterisk">*</span></label>
            <input 
              type="email" 
              pInputText 
              formControlName="fromAddress"
              readonly
              class="form-input">
          </div>

          <!-- 3. To -->
          <div class="form-field">
            <label class="field-label">To <span class="required-asterisk">*</span></label>
            <p-multiselect 
              class="form-multiselect"
              [options]="emails" 
              formControlName="toAddress" 
              display="chip" 
              [(ngModel)]="emails"
              placeholder="Select recipients">
      </p-multiselect>
          </div>

          <!-- 4. Subject -->
          <div class="form-field">
            <label class="field-label">Subject <span class="required-asterisk">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="subjectTitle"
              [ngClass]="{'invalid': clicked && !sendEmailForm.get('subjectTitle')?.valid}"
              class="form-input">
            <div *ngIf="clicked && !sendEmailForm.get('subjectTitle')?.valid" class="error-message">
              This field is required!
            </div>
          </div>

          <!-- 5. Attachment -->
          <div class="form-field">
            <label class="field-label">Attachment</label>
            <div class="upload-container">
              <div *ngIf="!attachmentFile || attachmentFile.length === 0" class="upload-dropzone" ngx-dropzone
                [accept]="'.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf'"
                [multiple]="false" 
                (change)="onSelectMedia($event, true)" 
                [maxFileSize]="2000000">
                <ngx-dropzone-label *ngIf="!uploadingFile" class="dropzone-content">
                  <div class="upload-icon">
                    <em class="pi pi-cloud-upload"></em>
                  </div>
                  <div class="upload-text">
                    Click to <span class="upload-link">upload</span> or Drag & Drop
                  </div>
                  <div class="upload-format">.XLSX, .CSV .DOCX .PDF Formats only</div>
                  <div class="upload-format">File should be Less than 2MB</div>
                </ngx-dropzone-label>
                <div *ngIf="uploadingFile" class="upload-loading">
                  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
                  </p-progressSpinner>
                </div>
              </div>
              
              <div *ngIf="attachmentFile && attachmentFile.length > 0" class="uploaded-file-container">
                <div class="uploaded-file-info" *ngFor="let f of attachmentFile">
                  <div class="file-icon">
                    <em class="pi pi-file"></em>
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ f.name }}</div>
                  </div>
                  <button 
                    type="button" 
                    class="remove-file-btn"
                    (click)="onRemoveMedia(f)">
                    <em class="pi pi-times"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 6. Message -->
          <div class="form-field">
            <div class="message-header">
              <label class="field-label" required>Message</label>
              <div class="message-actions" *ngIf="selectedTemplate">
                <span class="label-action" *ngIf="!editingTemplate" (click)="editEmailTemplate(true)">Edit</span>
                <span class="label-action" *ngIf="editingTemplate && placeholders.length" (click)="showPlaceholder = true">Add Placeholder</span>
                <span class="label-action" *ngIf="editingTemplate" (click)="editEmailTemplate(false)">Close</span>
              </div>
            </div>
            
            <div *ngIf="!editingTemplate && selectedTemplate" class="template-display" style="overflow-y: auto;">
              <div [innerHTML]="selectedTemplate?.body | getSafeHTMLEmail" style="pointer-events: none;">
              </div>
            </div>
            
            <div *ngIf="editingTemplate || !selectedTemplate" class="template-editor">
              <textarea placeholder="Email Body" id="content"></textarea>
            </div>
          </div>
    </form>
  
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="button"
        [label]="sendMailHeader"
        [loading]="loader"
        [disabled]="isSendButtonDisabled()"
        (click)="submit()"
        class="send-invite-btn">
      </button>
    </div>
</div>
</p-dialog>

<p-dialog header="Add Placeholder" [draggable]="false" [(visible)]="showPlaceholder" class="placeholder-dialog" position="topright"
  [style]="{position: 'fixed', top: '7.875rem', margin: '0 20px', maxWidth: '42vw', minWidth: '40vw', 'max-height': '300px'}" [baseZIndex]="9999">
  <p-chip *ngFor="let item of placeholders" label="{{item.tag}}" (click)="insertPlaceholder(item.value)"></p-chip>
</p-dialog>

<p-toast></p-toast>